import { render, staticRenderFns } from "./WorkflowKanbanCardItem.vue?vue&type=template&id=41744e78"
import script from "./WorkflowKanbanCardItem.vue?vue&type=script&lang=js"
export * from "./WorkflowKanbanCardItem.vue?vue&type=script&lang=js"
import style0 from "./WorkflowKanbanCardItem.vue?vue&type=style&index=0&id=41744e78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports